export default {
    namespaced: true,
    state: {
      active: false,
    },
    getters: {
      status: state => state.active,
    },
    mutations: {
      mutateHelp(state, data) {
        state.active = data;
      },
    },
    actions: {
      setHelp(context, data) {
        context.commit('mutateHelp', data);
      },
    },
  };
  